import { HTMLToPowerPointOptions, TextWithOptions } from "pptxgenjs"
import { MasterSlide } from "./master-slides"
import { Placeholder } from "./placeholders"

export function getHtmlToPowerPointBaseOptions(
	title: string
): HTMLToPowerPointOptions
export function getHtmlToPowerPointBaseOptions(
	titles: TextWithOptions[]
): HTMLToPowerPointOptions
export function getHtmlToPowerPointBaseOptions(
	titles: string | TextWithOptions[]
): HTMLToPowerPointOptions {
	return {
		addText: {
			opts: { placeholder: Placeholder.Title }, text: titles
		},
		addHeaderToEach: true,
		master: MasterSlide.TableWithTitle
	}
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/pptx-configuration/slides.ts